// extracted by mini-css-extract-plugin
export default {"container":"styles_container__9uIMg","form":"styles_form__ITbVx","item":"styles_item__2r92u"};